import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { recordWebVisitorV1ResponseSchema } from '../recordWebVisitorV1';

export const recordWebVisitorV2ResponseSchema = recordWebVisitorV1ResponseSchema;

export type IRecordWebVisitorV2Response = z.infer<typeof recordWebVisitorV2ResponseSchema> & IAPI;
